module.exports = __webpack_public_path__ + "img/29.2876c8fe.jpg";